/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sync_Last_Sync_Minutes_AgoInputs */



/**
* | output |
* | --- |
* | "{count} min ago" |
*
* @param {Sync_Last_Sync_Minutes_AgoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_last_sync_minutes_ago = /** @type {((inputs: Sync_Last_Sync_Minutes_AgoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Last_Sync_Minutes_AgoInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vor ${i?.count} Min.`)
	return /** @type {LocalizedString} */ (`${i?.count} min ago`)
});